import { ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu } from 'rangeConfig/@types';
import removeOrganizersFromSelectedEntity from 'rangeConfig/platsa/behaviors/removeOrganizersFromSelectedEntity';
import {
  canHaveLight,
  matchOrganizerToSelectedInterior
} from 'rangeConfig/platsa/filters/selectedMenuProductFilters';
import addOrReplaceAtTarget from 'rangeConfig/shared/behaviors/addOrReplaceAtTarget';
import { addProductToSelectedEntity } from 'rangeConfig/shared/behaviors/addProductToSelectedEntity';
import deleteProduct from 'rangeConfig/shared/behaviors/deleteProduct';
import removeTypeFromTarget from 'rangeConfig/shared/behaviors/removeTypeFromTarget';
import replaceProduct from 'rangeConfig/shared/behaviors/replaceProduct';
import {
  matchDepth,
  matchType,
  matchWidth
} from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import { noProductsWithTypesForSelectedEntity } from 'rangeConfig/shared/rules/noneOptionSelectedRules';

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListChangeInterior',
  behaviors: {
    productDeleted: [deleteProduct]
  },
  content: [
    {
      id: 'interiors-selected-menu-interiors',
      title: 'storageone.productListInteriorsTitle',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText',
      behaviors: {
        productClicked: [replaceProduct],
        productDropped: [replaceProduct]
      },
      productTypes: [
        ProductType.PLATSA_SHELF,
        ProductType.PLATSA_CLOTH_RAIL_40,
        ProductType.PLATSA_CLOTH_RAIL_55,
        ProductType.PLATSA_MULTIUSE_HANGER,
        ProductType.PLATSA_WIRE_BASKET_ASM,
        ProductType.PLATSA_SHOE_SHELF,
        ProductType.PLATSA_RAIL_STRIP_W_HOOKS_ASM,
        ProductType.PLATSA_CLOTH_RAIL_55_W_HOOKS_ASM
      ],
      productFilters: [matchWidth, matchDepth, matchType]
    },
    {
      id: 'interiors-selected-menu-cloth-rail-organizers',
      title: 'storageone.selectedProductListAddOrganizers',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText, communicatedSizeText',
      behaviors: {
        productClicked: [addProductToSelectedEntity],
        productDropped: [addProductToSelectedEntity]
      },
      productTypes: [ProductType.PLATSA_CLOTH_RAIL_ORGANIZER],
      productFilters: [matchOrganizerToSelectedInterior],
      noneOption: {
        behaviors: { removeProducts: [removeOrganizersFromSelectedEntity] },
        selected: noProductsWithTypesForSelectedEntity([ProductType.PLATSA_CLOTH_RAIL_ORGANIZER]),
        title: 'storageone.productListNoClothRailOrganisersOptionTitle'
      }
    },
    {
      id: 'interiors-selected-menu-shelf-organizers',
      title: 'storageone.selectedProductListAddOrganizers',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText, communicatedSizeText',
      behaviors: {
        productClicked: [addProductToSelectedEntity],
        productDropped: [addProductToSelectedEntity]
      },
      productTypes: [
        ProductType.PLATSA_SHELF_ORGANIZER,
        ProductType.PLATSA_SHELF_AND_DRAWER_ORGANIZER
      ],
      productFilters: [matchOrganizerToSelectedInterior],
      noneOption: {
        behaviors: { removeProducts: [removeOrganizersFromSelectedEntity] },
        selected: noProductsWithTypesForSelectedEntity([
          ProductType.PLATSA_SHELF_ORGANIZER,
          ProductType.PLATSA_SHELF_AND_DRAWER_ORGANIZER
        ]),
        title: 'storageone.productListNoShelfOrganisersOptionTitle'
      }
    },
    {
      id: 'interiors-selected-menu-lights',
      title: 'storageone.productListLightsTitle',
      cardsTitle: '',
      cardsSubtitle: 'typeName, designText',
      productThumbToolTip: 'typeName, designText',
      behaviors: {
        productClicked: [addOrReplaceAtTarget],
        productDropped: [addOrReplaceAtTarget]
      },
      productTypes: [ProductType.PLATSA_INNER_LIGHT],
      productFilters: [canHaveLight, matchWidth],
      noneOption: {
        behaviors: { removeProducts: [removeTypeFromTarget(ProductType.PLATSA_INNER_LIGHT)] },
        selected: noProductsWithTypesForSelectedEntity([ProductType.PLATSA_INNER_LIGHT]),
        title: 'storageone.productListNoInnerLightsOptionTitle'
      }
    }
  ]
};

export default selectedMenu;
